import type { EventDto } from '../../api/types';
import { isEventFull } from '../events/participants';

export type ResourceStatus = 'green' | 'yellow' | 'red';

// Status based on current user's participation
export type UserResourceStatus = 'brown' | 'green' | 'yellow';

export type ResourceState = {
  bookingsCount: number;
  status: ResourceStatus;
};

export function computeResourceState(events: EventDto[]): ResourceState {
  const bookingsCount = events.length;
  if (bookingsCount === 0) {
    return { bookingsCount: 0, status: 'green' };
  }

  const full = events.filter(isEventFull).length;
  if (full === bookingsCount) return { bookingsCount, status: 'red' };
  if (bookingsCount > 1 && full > 0) return { bookingsCount, status: 'yellow' };
  return { bookingsCount, status: 'green' };
}

/**
 * Determines resource border color based on user's participation:
 * - yellow: has pending invitation (highest priority)
 * - green: has confirmed participation
 * - brown: no participation (default)
 */
export function computeUserResourceStatus(
  events: EventDto[],
  telegramId: string | undefined
): UserResourceStatus {
  if (!telegramId || events.length === 0) {
    return 'brown';
  }

  let hasPending = false;
  let hasConfirmed = false;

  for (const event of events) {
    if (event.status !== 'active') continue;
    for (const p of event.participants) {
      if (p.telegramId === telegramId) {
        if (p.status === 'pending') hasPending = true;
        if (p.status === 'confirmed') hasConfirmed = true;
      }
    }
  }

  // Priority: pending > confirmed > brown
  if (hasPending) return 'yellow';
  if (hasConfirmed) return 'green';
  return 'brown';
}
